"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReinforcementBanner = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HeroBanner = require("../../HeroBanner");
var _ReinforcementBannerSide = require("./ReinforcementBannerSide/ReinforcementBannerSide");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ReinforcementBanner = exports.ReinforcementBanner = function ReinforcementBanner(_ref) {
  var Component = _ref.Component,
    PrimaryContentComponent = _ref.PrimaryContentComponent,
    SecondaryContentComponent = _ref.SecondaryContentComponent,
    primaryContentProps = _ref.primaryContentProps,
    secondaryContentProps = _ref.secondaryContentProps,
    styles = _ref.styles,
    qeId = _ref.qeId;
  return /*#__PURE__*/_react["default"].createElement(_HeroBanner.HeroBanner, {
    namespace: "ReinforcementBanner",
    Component: Component,
    PrimaryContentComponent: PrimaryContentComponent,
    SecondaryContentComponent: SecondaryContentComponent,
    primaryContentProps: primaryContentProps,
    secondaryContentProps: secondaryContentProps,
    styles: styles,
    qeId: qeId
  });
};
ReinforcementBanner.propTypes = {
  Component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string, _propTypes["default"].object]),
  PrimaryContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object]),
  SecondaryContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object]),
  primaryContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  secondaryContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  styles: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func])),
  qeId: _propTypes["default"].string
};
ReinforcementBanner.defaultProps = {
  Component: 'div',
  content: [],
  PrimaryContentComponent: _ReinforcementBannerSide.ReinforcementBannerSide,
  SecondaryContentComponent: _ReinforcementBannerSide.ReinforcementBannerSide,
  primaryContentProps: {},
  secondaryContentProps: {},
  styles: {},
  qeId: ''
};